var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Spin } from 'antd';
import { useTranslation } from 'react-i18next';
// Shown in place of a beta screen's content while the gate is loading, or when
// the active org/facility is not allowed to use the beta receiving/put-away flows.
var BetaGateNotice = function (_a) {
    var gate = _a.gate;
    var t = useTranslation().t;
    if (gate === 'loading') {
        return (_jsx("div", __assign({ className: 'flex justify-center py-12' }, { children: _jsx(Spin, {}, void 0) }), void 0));
    }
    return (_jsxs("div", __assign({ className: 'py-12 text-center' }, { children: [_jsx("p", __assign({ className: 'text-base font-semibold text-gray-700' }, { children: t('This feature is not enabled for this facility.') }), void 0), _jsx("p", __assign({ className: 'mt-1 text-sm text-gray-400' }, { children: t('Ask an administrator to enable it for your organization.') }), void 0)] }), void 0));
};
export default BetaGateNotice;
